import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { webPublishAppComponent } from './publish-app/publish-app.component';
import { FormsModule } from '@angular/forms';
import { MaterialModuleWeb } from '../material/material.module';
import { MatDialogModule } from '@angular/material/dialog';



@NgModule({
  declarations: [
    webPublishAppComponent
  ],
  imports: [
    CommonModule,
    FormsModule,
    MaterialModuleWeb,
    MatDialogModule
  ],
  exports: [
    webPublishAppComponent
  ]
})
export class webPublishAppModule { }
